import { trelloStore, StoreScope, StoreType } from '@/services/trellostore';
import StoreKeys from '@/services/storekeys';
import Icons from '@/icons';
import context from '@/services/ctx';
import channel from '@/cqs/channel';
import * as queries from  '@/cqs/queries'
import storymapAccess from '@/services/storymapaccess';
import {getDataForCardFront, getDataForCardBack, checkAccess} from '@/services/storiesonboardrepository';
import { CardData } from '@/cqs/remotequeries';
import { Dictionary } from 'typescript-collections';

class ReleaseModule implements ICardBadgesProvider,ICardDetailsBadgesProvider, ICardListSortersProvider {

    public getListSorters(t: ITrelloClient, opts: any): Promise<any[]> {
        return new Promise(async resolve => {
            var result = [];    

            var getCards = async () => {
                const list = await t.list('all');
                var hasAccess = await checkAccess(t);
                var cardDataMap = new Dictionary<string, CardData>();
                if(hasAccess) {
                    var cardDataTasks: Promise<CardData>[] = list.cards.select(card => getDataForCardFront(t, card.id));
                    var cardDatas = await Promise.all(cardDataTasks);
                    cardDatas.forEach(card => {
                        if(card != null) {
                            cardDataMap.setValue(card.Id, card);
                        }
                    });
                }
                var cards = [];
                list.cards.forEach(card => {
                    var cardData = cardDataMap.containsKey(card.id)
                        ? cardDataMap.getValue(card.id)
                        : null;
                    cards.push({ id: card.id, release: cardData?.Release });
                });

                return cards;
            }


            result = [
                {
                    text: "Releases (A -> Z)",
                    callback: async (t, opts) => {
                        var cards = await getCards();
                        var sortedCards = cards.sort(function(a,b) {
                            if(a.release == null){
                                return 1;
                            }
                            else if(b.release == null){
                                return -1;
                            }
                            else if (a.release > b.release) {
                                return 1;
                            } 
                            else if (b.release > a.release) {
                                return -1;
                            }
                            return 0;
                        });
                        return {
                            sortedIds: sortedCards.map(function (c) { return c.id; })
                        };
                    }
                },
                {
                    text: "Releases (Z -> A)",
                    callback: async (t, opts) => {
                        var cards = await getCards();
                        var sortedCards = cards.sort(function(a,b) {
                            if(a.release == null){
                                return 1;
                            }
                            else if(b.release == null){
                                return -1;
                            }
                            else if (a.release < b.release) {
                                return 1;
                            } 
                            else if (b.release < a.release) {
                                return -1;
                            }
                            return 0;
                        });
                        return {
                            sortedIds: sortedCards.map(function (c) { return c.id; })
                        };
                    }
                }
            ];
            
            resolve(result);
        });
    }


    public async getCardBadges(t: ITrelloClient, opts:any) : Promise<Array<any>> {
        var badges = [];    
        var hasAccess = await checkAccess(t);
        if(hasAccess) {
            var ctx = await context(t).get();
            var cfg = ctx.config;
            if (cfg.isShowReleases && cfg.isShowReleasesOnCardFront){
                var card = await getDataForCardFront(t, opts.context.card);
                if(card != null && card.Release != null) {
                    badges.push({
                        icon: Icons.Release.BadgeIcon,
                        text: card.Release.truncate(40)
                    })
                }
            }
        } 

        return badges;
    }


    public async getCardDetailsBadges(t: ITrelloClient, opts: any): Promise<any[]> {
        var badges = [];
        var hasAccess = await checkAccess(t);
        if(hasAccess) {
            var ctx = await context(t).get();
            var cfg = ctx.config;
            if (cfg.isShowReleases && cfg.isShowReleasesOnCardBack){
                var card = await getDataForCardBack(t, opts.context.card);
                if(card != null && card.Release != null) {
                    badges.push({
                        title: "Release",
                        text: card.Release.truncate(30),
                        callback: (t) => {
                            return t.popup({
                                title: 'Release details',
                                url: './views/relatedinfopopup.html',
                                args: { 
                                    title: card.Release,
                                    description: card.ReleaseDetails,
                                    url: card.ReleaseUrl
                                },
                                height: 150
                            });
                        }
                    })
                }
            }
        } 

        return badges;
    }
}

export var releaseModule = new ReleaseModule();
export default releaseModule;
